import { useEffect, useState } from "react";
import "./home.scss";
import HomeTemplate from "../../../componets/templates/homeTemplate/homeTemplate";
import axios from "axios";
import { baseURL } from "utilities/variables";
//SizeType puede ser 1, 2, 3, 4...
//type puede ser h -> h1 h2, etc o p -> párrafo
//fontWeight puede ser 100, 200, 300 o 400.

const Home = () => {
  const [data, setData] = useState(undefined);
  useEffect(() => {
    axios
      .get(baseURL + "/api/pagina-home")
      .then((response) => {
        let auxData = response.data.data.attributes;
        let auxEasyData = {
          title: auxData.tituloP2,
          subtitle: auxData.tituloP1,
          introductionText: auxData.subtitulo,
          description: auxData.descripcion,
        };

        setData(auxEasyData);
      })
      .catch(function (error) {
        console.log("Error al intentar traer los datos", error);
      });
  }, []);
  return (
    <div className="home__main-container">
      {data !== undefined ? <HomeTemplate data={data} /> : "Cargando datos"}
    </div>
  );
};

export default Home;
